<template>
	<div>
		<div class="global-search">
			<select class="global-search-select" v-model="select" slot="prepend" >
				<option v-for="item in selectList" :label="item.filedName" :value="item.filedCode" :key="item.filedCode"></option>
			</select>
			<input class="global-search-input" v-on:keyup.13="globalSearch" placeholder="输入后回车搜索" v-model="info" size="mini">
			</input>
			<span @click="globalSearch" class="icon-search iconfont">&#xe7ce;</span>
		</div>
		<div v-if="hasCustomer" class="mask"></div>
		<iframe id="opportunityEntry" v-if="hasCustomer" :src="navbardata.domainConfig.crmDomain + '/customer/global_search_new_details'" width="100%" height="100%" class="background-iframe"></iframe>
	</div>
</template>

<script>
import axios from "axios";
import { mapGetters } from 'vuex'
export default {
  name: "GlobalSearch",
  data(){
    return{
      info:'',
      select:'',
	  selectList:this.uniqueFiled,
      hasCustomer:false
	}
  },
  computed:{
    ...mapGetters('im',{
      navbardata:'currentUser'
    })
  },
  watch:{
    uniqueFiled:function (n,o) {
      console.log(n,'111111')
	  this.selectList = n
	  this.select = n[0].filedCode
    }
  },
  props:{
    uniqueFiled:{
		  type:Array,
      default:()=>{
		return[]
	  }
	}
  },
  methods:{
    globalSearch(){
     const parObj = this.selectList.filter(item=>{return item.filedCode === this.select})[0]
	  if(this.info.trim() === '' ){return}
      axios({
        url: '/apiCustomer/globalSearchCustomer',
        baseURL:this.navbardata.domainConfig.crmApiDomain,
        data:{
          "tableCode":parObj.tableCode,
		  "filedName":parObj.filedName,
		  "filedKey":parObj.filedCode,
		  "filedVal":this.info},
        method: 'post',
        isReplaceHeaders: true,
        headers: {
          "crmApiToken": window.localStorage.getItem("initToken")
        }
      }).then(res => {
        if (res.data.code === 200){
			this.hasCustomer = true
            this.message = {
              type: 'global_search_result',
              data: res.data.data
            };
          	var str = `&filedKey=${res.data.data.filedKey}&filedVal=${res.data.data.filedVal}`
          this.$parent.inputSuffix = str
          this.$nextTick(()=>{
              this.watch(this);
              let iframe = document.querySelector('#opportunityEntry')
              iframe.onload = () => {
				console.log( this.message, '发送的数据')
               this.send()
              }
			})
		}else{
          this.$toast(res.data.msg)
		}
	  })
	},
	send(){
      console.log('发送')
      document.getElementById('opportunityEntry').contentWindow.postMessage(
        JSON.stringify(this.message),'*')
	},
    closeIframe(){
      this.hasCustomer = false
	},
	watch(x){
	  let _this = x;
      window.addEventListener("message", function (event) {
        console.log(event, event.data,' hhhhhaaaaaaaaa');
        let data = {};
        try {
          data = JSON.parse(event.data);
        } catch (e) {
          console.log('JSON parse error!', event.data);
        }
        //关闭客户面板 || 关闭弹框
        if (data.type === 'close_crm_iframe_customer_panel') {
          _this.closeIframe();
        }
        //机会录入
        if(data.type === 'crm_iframe_customer_panel_input_customer'){
          _this.closeIframe();
          $('#customer_o_input')[0].click()
        }
      }, false);
	}
  },
  moutend(){

  },
  destroyed() {
    window.removeEventListener('message', () => {})
  }

}
</script>

<style scoped lang="less">
	.global-search{
		width: 242px;
		border-radius: 7px;
		padding-left: 4px;
		height: 26px;
		background-color: #fff;
		margin-top: 16px;
		display: flex;
		.global-search-select{
			height: 26px;
			font-size: 12px;
			border: 0px;
			outline: none;
			option{
				border: 0px;
			}
		}
		.global-search-input{
			height: 26px;
			width: 135px;
			font-size: 12px;
			border: 0px;
		}
		.icon-search{
			cursor:pointer;
			line-height: 26px;
			color: #666;
			font-size: 22px;
			font-weight: bold;
		}
	}
	.background-iframe{
		position: fixed;
		width: 100vw;
		left: 0px;
		height: 100vh;
		top: 0px;
		z-index: 999999991;
	}
	.mask{
		position: fixed;
		width: 100vw;
		left: 0px;
		height: 100vh;
		top: 0px;
		background-color: rgba(0,0,0,.3);
		z-index: 99999999;
	}
</style>



// WEBPACK FOOTER //
// src/components/GlobalSearch/GlobalSearch.vue